import React, { useState } from 'react';
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

// Wrapper component to replace react-fancybox
// This maintains similar API for backward compatibility
const ReactFancyBox = ({ thumbnail, image, caption, ...props }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <img
        src={thumbnail || image}
        alt={caption || ""}
        onClick={() => setIsOpen(true)}
        style={{
          cursor: 'pointer',
          maxWidth: '100%',
          height: 'auto',
        }}
        {...props}
      />
      
      <Lightbox
        open={isOpen}
        close={() => setIsOpen(false)}
        slides={[
          { src: image }
        ]}
      />
    </>
  );
};

export default ReactFancyBox;




